var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5601C2.00056 14.9561 2.85047 17.2733 4.39696 19.0953C5.94345 20.9173 8.08511 22.1245 10.437 22.5V15.4679H7.9V12.5601H10.44V10.3465C10.3839 9.82842 10.4419 9.30427 10.6098 8.81127C10.7777 8.31827 11.0515 7.86852 11.4116 7.49396C11.7718 7.1194 12.2095 6.82923 12.6936 6.64404C13.1778 6.45886 13.6965 6.3832 14.213 6.42246C14.963 6.43453 15.713 6.50195 16.453 6.62369V9.09786H15.189C14.9742 9.06955 14.7558 9.09017 14.5499 9.15821C14.3441 9.22624 14.1561 9.33995 13.9998 9.49093C13.8435 9.64191 13.7229 9.8263 13.647 10.0305C13.571 10.2346 13.5416 10.4534 13.561 10.6705V12.5601H16.332L15.889 15.4689H13.561V22.5C15.4486 22.1998 17.2112 21.3618 18.6402 20.085C20.0691 18.8082 21.1045 17.1461 21.6238 15.2957C22.143 13.4452 22.1244 11.4837 21.5702 9.64354C21.0159 7.80335 19.9492 6.16149 18.4964 4.91235C17.0435 3.6632 15.2653 2.85909 13.3724 2.59521C11.4794 2.33132 9.55092 2.61872 7.81525 3.42338C6.07958 4.22804 4.60942 5.51625 3.5788 7.13551C2.54819 8.75476 2.0003 10.6372 2 12.5601Z",
    fill: "#135DA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6ae1ca586b9f71493e405433149ce7ea.svg";
export { ForwardRef as ReactComponent };